import { Menu } from "@headlessui/react";
import { Check, MapPin } from 'lucide-react';

const LocationDropdown = ({ locations, selectedLocation, setSelectedLocation }: { locations: any[], selectedLocation: string | null, setSelectedLocation: any }) => {
    return (
        <Menu as="div" className="relative">
            <Menu.Button className="flex  w-full group px-2 py-1 text-sm items-center text-gray-200 lg:text-gray-500  dark:text-gray-200 ml-2">
                {selectedLocation}   <MapPin className="w-6 h-6 text-gray-200 lg:text-dark  dark:text-white ml-2" />
            </Menu.Button>

            <Menu.Items
                transition
                className="absolute max-h-[80vh] overflow-y-auto top-full left-1 -translate-x-1/3 mt-2 z-50 bg-white dark:bg-dark w-auto rounded-[10px] shadow-[0_4px_8px_-3px_rgba(5,83,156,0.15)] ring-1 ring-black ring-opacity-5 focus:outline-none transition duration-100 ease-out data-[closed]:scale-95 data-[closed]:opacity-0"
            >
                {locations?.map((location: any) => (
                    <Menu.Item key={location.locationID}>
                        {({ active }) => (
                            <button
                                onClick={() => setSelectedLocation(location.locationID)}
                                className={`${active ? "flex bg-gray-100 dark:bg-black/30" : ""
                                    } flex items-center w-full px-4 py-2 text-sm text-dark dark:text-gray-200`}
                            >
                                {selectedLocation === location.locationID ? (
                                    <Check className="w-4 h-4 text-primary-700 dark:text-white mr-2" />
                                ) : (
                                    <span className="w-4 h-4 mr-2" /> // empty space to keep alignment
                                )}
                                <span className="text-left">{location.locationID}</span>
                            </button>
                        )}
                    </Menu.Item>
                ))}
            </Menu.Items>
        </Menu>
    )

}

export default LocationDropdown;